import { render, staticRenderFns } from "./TopContent.vue?vue&type=template&id=b1395a3c"
import script from "./TopContent.vue?vue&type=script&lang=js"
export * from "./TopContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports